import {connect} from '~/redux/connect';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import ReactDom from 'react-dom';
import { HStack, IconButton, Image, Input, Link, Pressable, ReadonlyField, Tooltip, View } from '~/native-ui';
import modelApi from "~/backend/modelApi";
import getConfig from "~/config";
import authenticatedRequest from "~/backend/authenticatedRequest";
import {getEditFieldData, getItemId, getModelName} from "~/stateGetter";
import cn from 'classnames';
import {presentFieldFile} from "~/statePresenter";
import DialogGallery from "~/components/DialogGallyery/DialogGallery";
import * as DocumentPicker from "expo-document-picker";
import { Platform } from 'react-native';

class _FileField extends Component {
    static propTypes = {
        title: PropTypes.string.isRequired,
        editable: PropTypes.bool.isRequired,
        value: PropTypes.string,
        name: PropTypes.string.isRequired
    };

    static defaultProps = {
        progress: 0,
        isDone: false
    };

    constructor() {
        super();
        this.input = null;
    };

    state = {
        open: false,
    };

    renderReadonly = () => {
        // let { value } = this.props;
        return (
            <ReadonlyField className={this.props.className} label={this.renderLabel()} value="">
                {this.renderPreview()}
            </ReadonlyField>
        )
    };

    getInput = () => {
        return ReactDom.findDOMNode(this.input).querySelector('input')
    };

    uploadFile = (file) => {
        return (async () => {
            let { uploadFile } = modelApi(
                getConfig().baseUrl,
                this.props.modelName,
                (foo) => authenticatedRequest(foo, this.props.dispatch)
            );

            if(!file) { return; }

            this.setState({ progress: 0, isDone: false, uploadedFileName: file.name });

            let data = await uploadFile(this.props.name, file, (progress) => {
                this.setState({ progress });
            });

            this.setState({ progress: 0, isDone: true });

            this.props.onChange(data.filename);
            return data.filename;
        })();
    };

    renderPreview() {
        let value = this.props.value;
        if(!value.length) {
            return null;
        }

        if(this.props.type === 'image') {
            return [this.renderImagePreview(), this.renderDelete()];
        }

        return [this.renderFilePreview(), this.renderDelete()];
    }

    getFileUrl() {
        let { value } = this.props;

        return presentFieldFile({
            modelName: this.props.modelName,
            itemId: this.props.itemId,
            name: this.props.name,
            publicPath: this.props.publicPath,
            value,
        });
    }

    get _textProps() {
        return {
            _web: { 
                title: this.props.trans('download_file', { title: this.props.title }),
                style: { whiteSpace:"nowrap", textOverflow: "ellipsis", display: "block", overflow: "hidden", flex: 1 },
            }
        }
    }

    renderFilePreview() {
        let url = this.getFileUrl(),
            trans = this.props.trans;

        const title = trans('download_file', { title: this.props.title });

        return (
            <Tooltip tooltip={title}>
                <Link key="file_download" flex="1" href={url} target="_blank" _textProps={this._textProps}>{title}</Link>
            </Tooltip>
        );
    }

    previewRef = React.createRef();
    imageRef = React.createRef();


    renderImagePreview() {
        let url = this.getFileUrl();

        return (
            <View key="image_preview" className="previewContainer">
                <DialogGallery active={this.state.open} onClose={() => this.setState({open: false})} >
                    <Image source={url} style={{ height: "100%", width: "100%" }} resizeMode="contain" />
                </DialogGallery>

                <Pressable mx="auto" onPress={ () => this.setState({open: true})}>
                    <Image ref={ this.imageRef } resizeMode="contain" source={url} style={{ height: 200, width: 200 }} />
                </Pressable>
            </View>
        );
    }

    showPicker = async (e) => {
        if (e.target === this.previewRef.current || this.previewRef.current.contains(e.target)) {
            return;
        }

        let type = this.props.type === 'image' ? 'image/*' : "*/*";

        let result = await DocumentPicker.getDocumentAsync({ type });

        if (result.cancel) {
            this.props.onChange("");
            this.setState({ progress: 0, isDone: true, uploadedFileName: "" });
            return;
        }

        await this.uploadFile(result.output[0])
    }

    renderLabel() {
        return this.props.title?.split("/").pop() || "";
    }

    preventShowPicker (e) {
        e.preventDefault();
        e.stopPropagation();
    }

    renderUploadField() {
        let progressBarClassName = cn("progressBar", {
            ["animatedProgressBar"]: this.state.progress > 0,
            ["doneProgressBar"]: this.state.isDone,
        });

        const filename = (this.state.uploadedFileName || this.props.value)
            ?.split("/").pop() || "";

        return [
            <View key="progress-bar" position="absolute" bottom="0" left="0" height="2px" bg="primary.500" className={progressBarClassName} width={ this.state.isDone ? '100%' : this.state.progress+'%' } />,
            <Pressable key="pressable" onPress={ this.showPicker } maxWidth="100%">
                <Input
                    childrenBeforeInput
                    autoComplete={ Platform.OS === 'web' ? 'none' : 'off' }
                    ref={(i) => this.input = i}
                    label={this.renderLabel()}
                    value={filename}
                    onPress={this.showPicker}
                    error={this.props.validationMessage}
                    floating={false}
                    className={cn("field")}
                    iconRight={"cloud-upload"}
                    maxWidth="100%"
                >
                    <HStack ref={this.previewRef} alignItems="center" maxWidth="100%">
                        { this.renderPreview() }
                    </HStack>
                </Input>
            </Pressable>
        ];
    }

    handleRemove = () => {
        this.props.onChange("");
        this.setState({ progress: 0, isDone: true, uploadedFileName: "" });
    }

    renderDelete() {
        if(!this.props.value.length) { return null; }
        if(this.props.isReadonly) { return null; }

        return <IconButton flexGrow="0" ml="auto" key="delete" className="deleteButton" icon="remove" onClick={this.handleRemove} />
    }

    render() {
        // let className = cn(css.fieldContainer, this.props.className, { [css.notEmpty]: this.props.value.length });
        
        return (
            this.props.isReadonly ? this.renderReadonly() : this.renderUploadField()
        );
    }
}

const FileField = connect((state, {modelId}) => ({
    itemId: getItemId(state, modelId),
    modelName: getModelName(state, modelId),
}), (dispatch) => {
    return {
        dispatch
    }
})(_FileField);

export default FileField;